import { JsonObject, JsonProperty } from 'json2typescript';
import { PaginationAndSorting } from './pagination-and-sorting-model';

@JsonObject('SupplierFilters')
export class SupplierFilters extends PaginationAndSorting {
  @JsonProperty('filter', String, true) filter: string = undefined;
}
